import { DialogProps } from '@material-ui/core';
import { useCacheContext } from 'framework/hooks/useCacheContext';
import { ISale, salesCommand_patchLabels } from 'gen/ApiClient';
import React from 'react';
import { LabelsForm } from 'shared/LabelsForm';
import { SalesFilterDataContext } from '../SalesFilterDataContext';

interface IProps extends DialogProps {
	item: ISale;
	cancel: VoidFunction;
	confirm: VoidFunction;
}

export const SalesLabelsForm = ({ item, ...rest }: IProps) => {
	const [data] = useCacheContext(SalesFilterDataContext);

	if (data === undefined) {
		return <div></div>;
	}

	return (
		<LabelsForm
			{...rest}
			autoCompleteLabels={data.labels}
			labels={item.labels}
			updateF={values => salesCommand_patchLabels({ salesId: item.id, labels: values })}
		/>
	);
};
